/**
 * Haptics. SPEC.md §9.3, §36.
 *
 * A short buzz is the cheapest possible "I got that" for a control the player
 * isn't looking at. iOS Safari has no Vibration API at all, so this is a no-op
 * on a large share of devices and nothing may depend on it firing.
 */

export type HapticPattern = 'tap' | 'commit' | 'pickup' | 'error';

/** Kept short: anything longer reads as a notification, not as feedback. §20.4 */
const PATTERNS: Record<HapticPattern, number | number[]> = {
  tap: 8,
  commit: 14,
  pickup: 18,
  error: [10, 40, 10],
};

function vibrateFn(): ((pattern: number | number[]) => boolean) | null {
  if (typeof navigator === 'undefined') return null;
  const fn = navigator.vibrate;
  if (typeof fn !== 'function') return null;
  return fn.bind(navigator);
}

export function haptic(pattern: HapticPattern = 'tap'): void {
  const vibrate = vibrateFn();
  if (!vibrate) return;
  try {
    vibrate(PATTERNS[pattern]);
  } catch {
    // Some engines throw when the document has never been interacted with.
  }
}
